import { render, staticRenderFns } from "./nav_tabar.vue?vue&type=template&id=77d06c3c&scoped=true&"
import script from "./nav_tabar.vue?vue&type=script&lang=js&"
export * from "./nav_tabar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d06c3c",
  null
  
)

export default component.exports